import { LAYOUT_VERSION } from "app/layout-version";

export const BRAIN_SCALE = {
  50:  '#e6f5f5',   // superficie ultra clara
  100: '#c0e6e7',
  200: '#8dd4d5',
  300: '#5abebf',
  400: '#279e9f',   // accent  (light.accent del usuario)
  500: '#0f8084',   // primary (light.medium del usuario) ← tono base
  600: '#0a686c',
  700: '#02505c',   // strong  (light.strong del usuario)
  800: '#013c45',
  900: '#012830',   // superficie ultra oscura
} as const;

// ── Semánticos por modo ────────────────────────────────────────────────────
// IMPORTANTE: estos valores deben estar sincronizados con
// `src/@core/scss/base/core/colors/_brain-palette.scss`. Si cambias la paleta,
// actualiza ambos archivos (TS lo usa para inline styles vía ngStyle).
export const BRAIN_COLORS = {
  light: {
    primary:        '#0f8084',
    primaryHover:   '#0a686c',
    primaryDark:    '#02505c',
    primaryLight:   '#279e9f',
    primaryXLight:  '#e6f5f5',
    primaryRgb:     '15, 128, 132',
    primaryBg:      'rgba(15, 128, 132, 0.08)',
    primaryBgMd:    'rgba(15, 128, 132, 0.15)',
    primaryBgStr:   'rgba(15, 128, 132, 0.25)',
    onPrimary:      '#ffffff',
    headerFallbackBg: 'linear-gradient(110deg, rgb(48, 48, 56) 0%, rgb(35, 35, 40) 50%, rgb(26, 26, 32) 100%)', //'#4b4b4b',
    colorFavorites: '#0f8084'
  },
  dark: {
    primary:        '#38c0bb',
    primaryHover:   '#5de0db',
    primaryDark:    '#1f9e99',
    primaryLight:   '#5de0db',
    primaryXLight:  '#012830',
    primaryRgb:     '56, 192, 187',
    primaryBg:      'rgba(56, 192, 187, 0.08)',
    primaryBgMd:    'rgba(56, 192, 187, 0.15)',
    primaryBgStr:   'rgba(56, 192, 187, 0.25)',
    onPrimary:      '#ffffff',
    // Teal profundo de BRAIN_SCALE (600 → 700 → 800): se despega del fondo
    // grafito del tema oscuro (#1D1D22 / cards #28282F) y mantiene texto blanco
    // por encima de 6:1.
    headerFallbackBg:  'linear-gradient(110deg, rgb(48, 48, 56) 0%, rgb(35, 35, 40) 50%, rgb(26, 26, 32) 100%)',
    colorFavorites: '#38c0bb'
  },
} as const;

// ── Para gráficas (estructura compatible con colors.const.ts) ──────────────
export const brainChartColors = {
  solid: {
    primary:   '#0f8084',
    secondary: '#279e9f',
    tertiary:  '#02505c',
    light:     '#8dd4d5',
    xlight:    '#e6f5f5',
  },
  light: {
    primary:   '#0f80841a',
    secondary: '#279e9f1a',
    tertiary:  '#02505c1a',
  },
} as const;

// ── Colores que dependen de la versión del layout (ver app/layout-version.ts) ─
// Para inline styles que no pasan por el SCSS: con la versión 1 vuelven los
// valores que tenía master.
const IS_MASTER_LAYOUT = LAYOUT_VERSION === 1;

export const LAYOUT_COLORS = {
  primary:            IS_MASTER_LAYOUT ? '#7367f0' : BRAIN_COLORS.light.primary,
  swalConfirmButton:  IS_MASTER_LAYOUT ? '#3085d6' : BRAIN_COLORS.light.primary,
  swalCancelButton:   IS_MASTER_LAYOUT ? '#d33' : BRAIN_COLORS.light.headerFallbackBg,
} as const;
